<template>
  <span
    class="hit-floating-label__help"
    @mousedown.stop.prevent
    @mouseup.stop.prevent
    @click.stop.prevent
  >
    <slot />
  </span>
</template>

<script>
/**
 * Hosts HitHelp inside a floating-label chip.
 * - Stops label/input focus (help often sits in a former <label for>).
 * - Forces HitHelp tooltips to teleport (chip uses overflow clipping for ellipsis).
 */
export default {
  name: 'HitFloatingLabelHelp',
  provide() {
    return {
      hitForceFloatingTooltip: true,
    };
  },
};
</script>
